import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DocketService } from '../../../shared/index';
import { Docket } from '../../../models/index';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'update-status-dialog',
    templateUrl: './update-status-dialog.component.html',
    styleUrls: ['./update-status-dialog.component.css'],
    providers: [DocketService],
    standalone: true,
    imports: [MatButton]
})
export class UpdateStatusDialogComponent {
  selectedDockets: Array<Docket> = [];
  status: string;
  currentStatus: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private mdDialogRef: MatDialogRef<UpdateStatusDialogComponent>,
    private docketService: DocketService
  ) {
    this.selectedDockets = data.selected;
    this.status = data.status;
    this.currentStatus = data.currentStatus;
  }

  close() {
    this.mdDialogRef.close();
  }

  updateStatus() {
    const ids = this.selectedDockets.map((docket) => {
      return docket.id;
    });
    this.docketService
      .bulkUpdateStatus(ids, this.currentStatus, this.status)
      .subscribe((updated) => {
        this.mdDialogRef.close(true);
      });
  }
}
